import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import DateFormat from '../../core/DateFormat';
import { TabsHorizontal } from '../../core/TabsHorizontal';
import TitleWidget from '../../core/TitleWidget';

import { StyledBookTable } from './style';

const StyledTitleWidget = styled(TitleWidget)`
  color: #000;
  line-height: ${rem('30px')};
  margin-bottom: ${rem('25px')};
  margin-left: ${rem('7px')};
  padding-left: ${rem('37px')};

  & > svg {
    left: ${rem('-7px')};
    bottom: ${rem('-11px')};
    ${mediaqueries.greaterThan('tablet')`
      bottom: ${rem('-3px')};
    `}
    ${mediaqueries.greaterThan('desktop')`
      bottom: ${rem('-11px')};
      width: ${rem('48px')};
      height: ${rem('63px')};
  `};
  }
`;

const StyledBoxWeek = styled.div`
  position: relative;

  .menuHome {
    ${StyledBookTable} {
      display: none;
    }
  }

  ${StyledBookTable} {
    ${mediaqueries.greaterThan('desktop')`
  
      width: ${rem('204px')};
    `};
  }
`;

const StyledBoxSuperior = styled.div`
  margin-left: 0;
  margin-top: ${rem('25px')};
  overflow: hidden;
  position: relative;

  ${mediaqueries.greaterThan('mobile')`
    margin-top: ${rem('55px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    margin-top: ${rem('59px')};
  `};
`;

const StyledTabsHorizontal = styled(TabsHorizontal)`
  &:first-child {
    margin-left: ${rem('1px')};
  }
`;

const StyledDate = styled(DateFormat)`
  font-family: ${props => props.theme.fonts.medium};
`;

const StyledBoxGeneral = styled.div`
  overflow: hidden;
`;

const StyleBoxWrapper = styled.div`
  display: flex;
  transition: all 0.5s ease-in-out;
  width: 700%;

  ${props =>
    props.activeIndex &&
    css`
      transform: translate3d(
        ${'-14.28571428571429' * props.activeIndex}%,
        0,
        0
      );
    `};

  ${mediaqueries.greaterThan('desktop')`
    transition: none;
  `};
`;

const StyledBoxDay = styled.div`
  margin-left: 0;
  width: 14.28571428571429%;
  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    margin-left: 0;
  `};
`;

const StyledWrapperNoMenu = styled.div`
  margin-top: ${rem('55px')};
`;

export {
  StyledTitleWidget,
  StyledBoxWeek,
  StyledBoxSuperior,
  StyledTabsHorizontal,
  StyledDate,
  StyledBoxGeneral,
  StyleBoxWrapper,
  StyledBoxDay,
  StyledWrapperNoMenu
};
